import React from 'react'
import styled from 'styled-components'

const Container = styled.div`
  position:relative;
  width:100%;
  margin-bottom: 10px;

  ::-webkit-input-placeholder { /* Edge */
    color: #999999;
    font-size: 14px;
  }

  :-ms-input-placeholder { /* Internet Explorer 10-11 */
    color: #999999;
    font-size: 14px;
  }

  ::placeholder {
    color: #999999;
    font-size: 14px;
  }
`

const Label = styled.label`
  position: absolute;
  top: -12px;
  left: 14px;
  margin: 0px;
  background-color: #fff;
  color: #222;
  font-size: 12px;
  font-family: 'Open Sans';
  font-weight: 400;
  padding: 4px;
  z-index: 1;
`

const TextareaStyled = styled.textarea`
  width: 100%;
  height: 88px;
  text-align: left;
  padding: 16px;
  border: 1px solid #777;
  border-radius: 8px;
  -moz-border-radius: 8px;
  -webkit-border-radius: 8px;
  color: #777;
  font-size: 16px;
  background-color: #fff;
  display: block;
  ${({ height }) => `${height}px; min-height: ${height}px; max-height: ${height}px; resize: none;`}
`

const ErrorMessage = styled.p`
  color: #ff0000;
  font-size: 13px;
  font-family: 'Open Sans';
  font-weight: 400;
  margin: 0px;
`

const Textarea = ({ id, label, name, onChange, value, isReadOnly, placeholder, onBlur, autoComplete, maxLength, height, errorMessage, hookForm }) => {
  const hasError = !!errorMessage
  const textareaProps = {
    id,
    name,
    onChange,
    value,
    readOnly: isReadOnly,
    placeholder,
    onBlur,
    autoComplete,
    maxLength,
    height,
    ...hookForm
  }

  return (
    <Container>
      {label && (<Label>{label}</Label>)}
      <TextareaStyled {...textareaProps}>{value}</TextareaStyled>
      {hasError && (<ErrorMessage>{errorMessage}</ErrorMessage>)}
    </Container>
  )
}

export default Textarea
